export const HamburgerIcon = () => {
  return (
    <svg
      width="26"
      height="22"
      viewBox="0 0 31 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line y1="1.25" x2="31" y2="1.25" stroke="#4E4F4E" strokeWidth="1.5" />
      <line y1="12.25" x2="31" y2="12.25" stroke="#4E4F4E" strokeWidth="1.5" />
      <line y1="23.25" x2="31" y2="23.25" stroke="#4E4F4E" strokeWidth="1.5" />
    </svg>
  );
};

export const PhotoIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.2364 20.4357L22.3492 14.5848L16.4619 20.4064M24.3116 28.2368L6.64991 10.6842L0.762695 16.5351"
        stroke="#7A7A7B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="0.5" y="0.5" width="28" height="28" rx="4.5" stroke="#7A7A7B" />
      <circle cx="20.1369" cy="8.1403" r="1.28532" fill="#7A7A7B" />
    </svg>
  );
};
